import { GeometrySelectionTypes } from "./types";

export const POLYGON_LIKE_TOOLS = [
  GeometrySelectionTypes.Circle,
  GeometrySelectionTypes.Rect,
  GeometrySelectionTypes.Polygon,
];
